export default new (class Category {
    constructor() {
        this.categoryDescription = "_category-description"
        this.categoryDescriptionToggle = "_category-description--toggle"
        this.categoryToggleBtn = "_category--toggleBtn"
        this.handler()
    }

    handler() {
        const categoryDescription = document.querySelector(`.${this.categoryDescription}`)

        if (!categoryDescription) return

        document.addEventListener("DOMContentLoaded", () => {
            //если в списке элементов больше 4 на мобиле
            if(window.innerWidth < 768) {
                this.categoryToggle()
            }
        })
    }

    categoryToggle() {

        if(document.querySelector(`.${this.categoryDescription}`).offsetHeight > 144) {
            document.querySelector(`.${this.categoryDescription}`).classList.add(`${this.categoryDescriptionToggle}`);
            document.querySelector(`.${this.categoryToggleBtn}`).style.display = 'block';
        }
        document.querySelector(`.${this.categoryToggleBtn}`).addEventListener("click", (obEvent) => {
            document.querySelector(`.${this.categoryDescription}`).classList.remove(`${this.categoryDescriptionToggle}`)
            obEvent.target.style.display = 'none';
        })
    }
})()
